import { useCallback, useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { TurnoService } from "../../../services/auxiliar/turnoService";
import { EstadoEquipoService } from "../../../services/auxiliar/estadoEquipoService";


export const useComboEstadoEquipo = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterEstado, setfilterEstado] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboEstado, setDataComboEstado] = useState<IComboBoxOption[]>([]);
    const comboBoxRefEstado = useRef<IComboBox>(null);

    const onClickComboTurno = () => comboBoxRefEstado.current?.focus(true);

    const onChangeEstado = (value: any) => {
        setfilterEstado({ ...filterEstado, search: value });
    }
    const listarComboEstado = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        EstadoEquipoService.ListarEstado(filterEstado, newController).then((res) => {
            if (res.status === 200) {
                setDataComboEstado(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarComboEstado();
        }
    }, [isOpen]);

    useEffect(() => {
        if (filterEstado.search != "") {
            listarComboEstado()
        }
    }, [filterEstado.search])

    return {
        dataComboEstado,
        onClickComboTurno,
        comboBoxRefEstado,
        onChangeEstado,
        filterEstado,
        setfilterEstado
    };
}

